(function () {
  var MAX_SOURCE_BYTES = 24 * 1024 * 1024;
  var MAX_EDGE = 1600;
  var JPEG_QUALITY = 0.86;
  var INITIAL_GROUP_LIMIT = 6;
  var ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];
  var HISTORY_DB_NAME = "bloomingful-inspo-finder";
  var HISTORY_STORE = "searches";
  var HISTORY_TTL_MS = 180 * 24 * 60 * 60 * 1000;
  var HISTORY_MAX_ENTRIES = 12;
  var HISTORY_MAX_BYTES = 24 * 1024 * 1024;
  var MAX_PREPARED_BYTES = 3 * 1024 * 1024;
  var PALETTE = {
    white: "#f8f6f1",
    cream: "#eee1cd",
    natural: "#c9b89a",
    brown: "#795541",
    pink: "#d99ca9",
    red: "#a33c45",
    burgundy: "#6c2538",
    orange: "#d56c3f",
    terracotta: "#b65d46",
    yellow: "#ddb84e",
    gold: "#b68b36",
    green: "#6d8467",
    blue: "#6285a2",
    teal: "#397e80",
    purple: "#776184",
    gray: "#8a8985",
    silver: "#b8b9b6",
    black: "#262626"
  };

  function initialize(root) {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    var endpoint = String(root.dataset.endpoint || "").replace(/\/$/, "");
    var projectEndpoint = String(root.dataset.projectEndpoint || "/apps/bloomingful-projects").replace(/\/$/, "");
    var customerSignedIn = root.dataset.customerSignedIn === "true";
    var customerEmail = String(root.dataset.customerEmail || "");
    var form = root.querySelector("[data-finder-form]");
    var input = root.querySelector("[data-file-input]");
    var uploadZone = root.querySelector("[data-upload-zone]");
    var workbench = root.querySelector(".bf-visual-finder__workbench");
    var replaceButton = root.querySelector("[data-replace-image]");
    var previewPanel = root.querySelector("[data-preview-panel]");
    var previewImage = root.querySelector("[data-preview-image]");
    var fileName = root.querySelector("[data-file-name]");
    var fileDetails = root.querySelector("[data-file-details]");
    var submit = root.querySelector("[data-submit]");
    var submitLabel = root.querySelector("[data-submit-label]");
    var spinner = root.querySelector("[data-spinner]");
    var message = root.querySelector("[data-message]");
    var status = root.querySelector("[data-status]");
    var results = root.querySelector("[data-results]");
    var resultGroups = root.querySelector("[data-result-groups]");
    var palette = root.querySelector("[data-palette]");
    var scene = root.querySelector("[data-scene]");
    var notice = root.querySelector("[data-result-notice]");
    var feedback = root.querySelector("[data-feedback]");
    var feedbackStatus = root.querySelector("[data-feedback-status]");
    var projectSave = root.querySelector("[data-project-save]");
    var projectSignedOut = root.querySelector("[data-project-signed-out]");
    var projectSignedIn = root.querySelector("[data-project-signed-in]");
    var projectBoard = root.querySelector("[data-project-board]");
    var projectSaveButton = root.querySelector("[data-project-save-button]");
    var projectSaveAllButton = root.querySelector("[data-project-save-all]");
    var projectNewForm = root.querySelector("[data-project-new-form]");
    var projectNewName = root.querySelector("[data-project-new-name]");
    var projectSelectAll = root.querySelector("[data-project-select-all]");
    var projectSelectNone = root.querySelector("[data-project-select-none]");
    var projectSelectionCount = root.querySelector("[data-project-selection-count]");
    var projectStatus = root.querySelector("[data-project-status]");
    var imageLibrary = root.querySelector("[data-image-library]");
    var imageTabs = root.querySelector("[data-image-tabs]");
var reviewRequest = root.querySelector("[data-review-request]");
    var reviewRequestForm = root.querySelector("[data-review-request-form]");
    var reviewEmail = root.querySelector("[data-review-email]");
    var reviewRequestButton = root.querySelector("[data-review-request-button]");
    var reviewRequestStatus = root.querySelector("[data-review-request-status]");
    var teamReview = root.querySelector("[data-team-review]");
    var teamReviewMessage = root.querySelector("[data-team-review-message]");
    var teamReviewDate = root.querySelector("[data-team-review-date]");
    var state = { dataUrl: "", entryId: "", searchId: "", controller: null, progressTimers: [], projectProducts: {}, projectBoards: [], history: [], currentPayload: null };

    input.addEventListener("change", function () {
      if (input.files && input.files.length) selectFiles(input.files);
      input.value = "";
    });
    replaceButton.addEventListener("click", function () { input.click(); });
    ["dragenter", "dragover"].forEach(function (eventName) {
      uploadZone.addEventListener(eventName, function (event) {
        event.preventDefault();
        uploadZone.classList.add("is-dragging");
      });
    });
    ["dragleave", "drop"].forEach(function (eventName) {
      uploadZone.addEventListener(eventName, function (event) {
        event.preventDefault();
        uploadZone.classList.remove("is-dragging");
      });
    });
    uploadZone.addEventListener("drop", function (event) {
      var files = event.dataTransfer && event.dataTransfer.files;
      if (files && files.length) selectFiles(files);
    });
    form.addEventListener("submit", runSearch);
    feedback.addEventListener("click", submitFeedback);
    if (projectSaveButton) projectSaveButton.addEventListener("click", function () { saveSelectedProducts(false); });
    if (projectSaveAllButton) projectSaveAllButton.addEventListener("click", function () { saveSelectedProducts(true); });
    if (projectBoard) projectBoard.addEventListener("change", toggleNewProjectForm);
    if (projectNewForm) projectNewForm.addEventListener("submit", createInlineProject);
    if (projectSelectAll) projectSelectAll.addEventListener("click", function () { setProjectSelection(true); });
    if (projectSelectNone) projectSelectNone.addEventListener("click", function () { setProjectSelection(false); });
    if (resultGroups) resultGroups.addEventListener("change", updateSelectionCount);
    if (imageTabs) imageTabs.addEventListener("click", handleImageTabAction);
    if (reviewRequestForm) reviewRequestForm.addEventListener("submit", submitReviewRequest);
    if (reviewEmail && !reviewEmail.value && customerEmail) reviewEmail.value = customerEmail;
    restoreHistory();

    async function selectFiles(fileList) {
      clearMessage();
      hideResults();
      state.dataUrl = "";
      submit.disabled = true;
      setBusy(true, "Preparing image...");
      try {
        var files = Array.prototype.slice.call(fileList, 0, HISTORY_MAX_ENTRIES);
        var preparedEntries = [];
        for (var index = 0; index < files.length; index += 1) {
          var file = files[index];
          if (!isAllowedFile(file)) throw new Error("Choose JPG, PNG, or WebP images.");
          if (file.size > MAX_SOURCE_BYTES) throw new Error("Choose images smaller than 24 MB.");
          var prepared = await prepareImage(file);
          preparedEntries.push({
            id: localId(),
            createdAt: Date.now() + index,
            fileName: file.name || "Inspiration image",
            width: prepared.width,
            height: prepared.height,
            dataUrl: prepared.dataUrl,
            payload: null,
            scope: selectedScopeValue()
          });
        }
        var historySaved = true;
        for (var entryIndex = preparedEntries.length - 1; entryIndex >= 0; entryIndex -= 1) {
          try { await saveHistoryEntry(preparedEntries[entryIndex]); }
          catch (historyError) { historySaved = false; }
        }
        if (historySaved) await loadHistoryEntries();
        else {
          state.history = preparedEntries.concat(state.history).slice(0, HISTORY_MAX_ENTRIES);
          renderHistory();
        }
        if (preparedEntries[0]) activateEntry(preparedEntries[0], { scroll: false });
      } catch (error) {
        showMessage(error.message || "This image could not be prepared. Try another file.");
      } finally {
        setBusy(false);
      }
    }

    async function runSearch(event) {
      event.preventDefault();
      if (!state.dataUrl || !endpoint) {
        showMessage(!endpoint ? "Visual search is unavailable right now." : "Choose an image first.");
        return;
      }
      clearMessage();
      hideResults();
      if (state.controller) state.controller.abort();
      state.controller = new AbortController();
      setBusy(true, "Analyzing visible flowers, foliage, shape, and color...");
      startProgress();
      try {
        var payload = await requestVisualSearch(state.dataUrl, selectedScopeValue(), false);
        state.currentPayload = payload;
        var active = historyEntry(state.entryId);
        if (active) {
          active.payload = payload;
          active.scope = selectedScopeValue();
          active.createdAt = Date.now();
          active.dataUrl = state.dataUrl;
          try {
            await saveHistoryEntry(active);
            await loadHistoryEntries();
          } catch (historyError) {
            renderHistory();
          }
        }
        renderResults(payload, { persist: false });
      } catch (error) {
        if (error.name !== "AbortError") showMessage(error.message || "Visual search could not be completed. Please try again.");
      } finally {
        stopProgress();
        setBusy(false);
      }
    }

    async function requestVisualSearch(dataUrl, scope, retried) {
      var response = await fetch(endpoint, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        signal: state.controller.signal,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ imageDataUrl: dataUrl, scope: scope })
      });
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok && !retried && /decode|decodable|source image/i.test(String(payload.error || ""))) {
        var repaired = await prepareImage(await dataUrlToBlob(dataUrl), { maxEdge: 1200, quality: 0.74 });
        state.dataUrl = repaired.dataUrl;
        return requestVisualSearch(repaired.dataUrl, scope, true);
      }
      if (!response.ok) throw new Error(payload.error || "Visual search could not be completed.");
      return payload;
    }

    function renderResults(payload, options) {
      options = options || {};
      state.currentPayload = payload;
      state.searchId = payload.search_id || "";
      resultGroups.replaceChildren();
      palette.replaceChildren();
      scene.textContent = payload.scene || "";
      notice.textContent = payload.notice || "";
      feedback.hidden = false;
      feedbackStatus.textContent = "";
      feedback.querySelectorAll("button").forEach(function (button) { button.disabled = false; });
      renderTeamReview(payload.team_review || null);
      configureReviewRequest(payload);

      (payload.palette || []).forEach(function (color) {
        var chip = element("span", "bf-visual-finder__palette-chip");
        var dot = element("span", "bf-visual-finder__palette-dot");
        dot.style.setProperty("--palette-color", PALETTE[color] || "#ded8cf");
        dot.setAttribute("aria-hidden", "true");
        chip.append(dot, document.createTextNode(labelize(color)));
        palette.append(chip);
      });

      var groups = payload.groups || [];
      state.projectProducts = {};
      groups.forEach(function (group) {
        (group.results || []).forEach(function (product) {
          var key = projectProductKey(product);
          if (key) state.projectProducts[key] = product;
        });
      });
      groups.slice(0, INITIAL_GROUP_LIMIT).forEach(function (group) {
        resultGroups.append(renderGroup(group));
      });
      if (groups.length > INITIAL_GROUP_LIMIT) {
        var remainingCount = groups.length - INITIAL_GROUP_LIMIT;
        var moreId = "bf-visual-finder-more-" + String(state.searchId || Date.now()).replace(/[^a-z0-9-]/gi, "");
        var moreGroups = element("div", "bf-visual-finder__more-groups");
        var moreButtonWrap = element("div", "bf-visual-finder__more-wrap");
        var moreButton = element("button", "bf-visual-finder__more-button");
        moreGroups.id = moreId;
        moreGroups.hidden = true;
        groups.slice(INITIAL_GROUP_LIMIT).forEach(function (group) {
          moreGroups.append(renderGroup(group));
        });
        moreButton.type = "button";
        moreButton.setAttribute("aria-expanded", "false");
        moreButton.setAttribute("aria-controls", moreId);
        moreButton.textContent = "Show " + remainingCount + " more identified " + (remainingCount === 1 ? "material" : "materials");
        moreButton.addEventListener("click", function () {
          moreGroups.hidden = false;
          moreButton.setAttribute("aria-expanded", "true");
          moreButtonWrap.remove();
        });
        moreButtonWrap.append(moreButton);
        resultGroups.append(moreButtonWrap, moreGroups);
      }
      if (!groups.length) {
        var empty = element("div", "bf-visual-finder__empty");
        empty.textContent = "We couldn't clearly identify the flowers or greenery. Try a closer photo of the arrangement.";
        resultGroups.append(empty);
      }
      results.hidden = false;
      configureProjectSave();
      updateSelectionCount();
      if (options.scroll !== false) results.scrollIntoView({ behavior: reducedMotion() ? "auto" : "smooth", block: "start" });
      if (!options.skipReviewSync) syncTeamReview(payload).catch(function () {});
    }

    function renderGroup(group) {
      var section = element("section", "bf-visual-finder__group");
      var header = element("div", "bf-visual-finder__group-head");
      var copy = document.createElement("div");
      var heading = document.createElement("h3");
      var count = document.createElement("p");
      var link = document.createElement("a");
      var grid = element("div", "bf-visual-finder__grid");
      heading.textContent = group.label || "Related florals";
      count.textContent = group.results && group.results.length
        ? group.results.length + (group.results.length === 1 ? " suggested match" : " suggested matches")
        : "No direct product suggestions";
      copy.append(heading, count);
      link.href = safeStoreUrl(group.collection_url);
      link.textContent = group.collection_label || "View complete collection";
      header.append(copy, link);
      section.append(header);

      (group.results || []).forEach(function (product) { grid.append(renderProduct(product)); });
      if (!group.results || !group.results.length) {
        var empty = element("div", "bf-visual-finder__empty");
        empty.textContent = "We couldn't find a close product match. You may find another option in the full collection.";
        grid.append(empty);
      }
      section.append(grid);
      return section;
    }

    function renderProduct(product) {
      var article = element("article", "bf-visual-finder__product");
      var classification = resultClassification(product);
      article.classList.add("bf-visual-finder__product--" + classification);
      var link = document.createElement("a");
      var media = element("div", "bf-visual-finder__product-media");
      var copy = element("div", "bf-visual-finder__product-copy");
      var match = element("span", "bf-visual-finder__match");
      var title = document.createElement("h4");
      var price = element("div", "bf-visual-finder__price");
      var reasons = element("p", "bf-visual-finder__reasons");
      link.href = safeStoreUrl(product.url);
      match.textContent = classificationLabel(classification);
      title.textContent = product.title || "Bloomingful floral";
      reasons.textContent = (product.reasons || []).filter(function (reason) {
        return reason !== "currently out of stock";
      }).join(" / ");

      if (product.image && safeImageUrl(product.image.url)) {
        var image = document.createElement("img");
        image.src = product.image.url;
        image.alt = product.image.alt || product.title || "Bloomingful floral product";
        image.loading = "lazy";
        image.decoding = "async";
        media.append(image);
      }
      if (!product.available) {
        var stock = element("span", "bf-visual-finder__stock");
        stock.textContent = "Out of stock";
        article.append(stock);
      }
      if (product.price) {
        if (window.bloomingfulCustomerHasWholesaleAccess) {
          price.textContent = "View current wholesale pricing";
        } else {
          var current = document.createElement("span");
          current.textContent = money(product.price);
          price.append(current);
          if (Number(product.compareAtPrice) > Number(product.price)) {
            var compare = document.createElement("s");
            compare.textContent = money(product.compareAtPrice);
            price.append(compare);
          }
        }
      }
      copy.append(match, title);
      if (price.childNodes.length) copy.append(price);
      if (reasons.textContent) copy.append(reasons);
      link.append(media, copy);
      article.append(link);
      if (product.id && product.variant && product.variant.id) {
        var projectChoice = element("label", "bf-visual-finder__project-choice");
        var projectInput = document.createElement("input");
        projectInput.type = "checkbox";
        projectInput.value = projectProductKey(product);
        projectInput.checked = true;
        projectInput.setAttribute("data-project-product", "");
        projectChoice.append(projectInput, document.createTextNode("Include in project"));
        article.append(projectChoice);
      }
      return article;
    }

    function configureProjectSave() {
      if (!projectSave) return;
      projectSave.hidden = false;
      projectStatus.textContent = "";
      projectSignedOut.hidden = customerSignedIn;
      projectSignedIn.hidden = !customerSignedIn;
      if (!customerSignedIn) return;
      projectBoard.innerHTML = '<option value="">Loading projects...</option>';
      setProjectButtonsDisabled(true);
      projectApi("").then(function (payload) {
        state.projectBoards = (payload.boards || []).filter(function (board) { return board.status === "active"; });
        projectBoard.replaceChildren();
        state.projectBoards.forEach(function (board) {
          var option = document.createElement("option");
          option.value = board.id;
          option.textContent = board.name;
          projectBoard.append(option);
        });
        var createOption = document.createElement("option");
        createOption.value = "__new__";
        createOption.textContent = state.projectBoards.length ? "+ Create a new project" : "Create your first project";
        projectBoard.append(createOption);
        if (!state.projectBoards.length) projectBoard.value = "__new__";
        toggleNewProjectForm();
        setProjectButtonsDisabled(!state.projectBoards.length);
      }).catch(function (error) {
        projectBoard.innerHTML = '<option value="">Projects unavailable</option>';
        projectStatus.textContent = error.message || "Projects could not be loaded.";
      });
    }

    function toggleNewProjectForm() {
      if (!projectNewForm || !projectBoard) return;
      var creating = projectBoard.value === "__new__";
      projectNewForm.hidden = !creating;
      setProjectButtonsDisabled(creating || !projectBoard.value);
      if (creating) window.setTimeout(function () { projectNewName.focus(); }, 0);
    }

    async function createInlineProject(event) {
      event.preventDefault();
      var name = String(projectNewName.value || "").trim();
      if (!name) {
        projectStatus.textContent = "Enter a project name.";
        projectNewName.focus();
        return;
      }
      projectStatus.textContent = "Creating project...";
      var button = projectNewForm.querySelector("button");
      button.disabled = true;
      try {
        var payload = await projectApi("/boards", { method: "POST", body: { name: name } });
        state.projectBoards.unshift(payload.board);
        var option = document.createElement("option");
        option.value = payload.board.id;
        option.textContent = payload.board.name;
        projectBoard.insertBefore(option, projectBoard.firstChild);
        projectBoard.value = payload.board.id;
        projectNewName.value = "";
        projectNewForm.hidden = true;
        setProjectButtonsDisabled(false);
        projectStatus.textContent = "Project created. Choose which products to save.";
      } catch (error) {
        projectStatus.textContent = error.message || "The project could not be created.";
      } finally {
        button.disabled = false;
      }
    }

    async function saveSelectedProducts(saveAll) {
      var boardId = projectBoard && projectBoard.value;
      if (!boardId || boardId === "__new__") {
        projectStatus.textContent = "Choose or create a project first.";
        return;
      }
      var selectedIds = [];
      root.querySelectorAll(saveAll ? "[data-project-product]" : "[data-project-product]:checked").forEach(function (input) {
        if (selectedIds.indexOf(input.value) === -1) selectedIds.push(input.value);
      });
      if (!state.currentPayload || !state.searchId || !state.dataUrl) {
        projectStatus.textContent = "Run this inspiration search again before saving it.";
        return;
      }
      setProjectButtonsDisabled(true);
      projectStatus.textContent = "Saving inspiration and " + selectedIds.length + (selectedIds.length === 1 ? " selected product..." : " selected products...");
      try {
        var active = historyEntry(state.entryId);
        await projectApi("/inspirations", {
          method: "POST",
          body: {
            board_id: boardId,
            search_id: state.searchId,
            label: inspirationLabel(active),
            scope: active && active.scope ? active.scope : selectedScopeValue(),
            scene: state.currentPayload.scene || "",
            palette: state.currentPayload.palette || [],
            groups: state.currentPayload.groups || [],
            selected_product_keys: selectedIds,
            image_data_url: state.dataUrl
          }
        });
        projectStatus.innerHTML = "Inspiration saved with " + selectedIds.length + (selectedIds.length === 1 ? " selected product. " : " selected products. ") + '<a href="/account#ProjectBoardsPanel">Open project boards</a>.';
      } catch (error) {
        projectStatus.textContent = error.message || "This inspiration could not be saved.";
      } finally {
        setProjectButtonsDisabled(false);
      }
    }

    function setProjectSelection(selected) {
      root.querySelectorAll("[data-project-product]").forEach(function (item) { item.checked = selected; });
      updateSelectionCount();
    }

    function updateSelectionCount() {
      if (!projectSelectionCount) return;
      var total = root.querySelectorAll("[data-project-product]").length;
      var selected = root.querySelectorAll("[data-project-product]:checked").length;
      projectSelectionCount.textContent = selected + " of " + total + " selected";
    }

    function setProjectButtonsDisabled(disabled) {
      if (projectSaveButton) projectSaveButton.disabled = disabled;
      if (projectSaveAllButton) projectSaveAllButton.disabled = disabled;
    }

    function projectProductKey(product) {
      if (!product || !product.id || !product.variant || !product.variant.id) return "";
      return String(product.id) + "|" + String(product.variant.id);
    }

    function inspirationLabel(entry) {
      var name = String(entry && entry.fileName || "").replace(/\.[a-z0-9]+$/i, "").replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
      return name ? name.slice(0, 120) : "Saved inspiration";
    }

    function projectApi(path, options) {
      options = options || {};
      return fetch(projectEndpoint + path, {
        method: options.method || "GET",
        credentials: "same-origin",
        headers: options.body ? { "Content-Type": "application/json" } : {},
        body: options.body ? JSON.stringify(options.body) : undefined
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok || payload.ok === false) throw new Error(payload.error || "Project request failed.");
          return payload;
        });
      });
    }

    async function submitFeedback(event) {
      var button = event.target.closest("[data-feedback-value]");
      if (!button || !state.searchId) return;
      feedback.querySelectorAll("button").forEach(function (item) { item.disabled = true; });
      feedbackStatus.textContent = "Saving...";
      try {
        var response = await fetch(endpoint + "/feedback", {
          method: "POST",
          mode: "cors",
          credentials: "omit",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_id: state.searchId, helpful: button.dataset.feedbackValue === "true" })
        });
        if (!response.ok) throw new Error();
        feedbackStatus.textContent = "Thank you.";
      } catch (error) {
        feedbackStatus.textContent = "Feedback could not be saved.";
        feedback.querySelectorAll("button").forEach(function (item) { item.disabled = false; });
      }
    }

    async function submitReviewRequest(event) {
      event.preventDefault();
      var payload = state.currentPayload || {};
      var email = String(reviewEmail && reviewEmail.value || "").trim();
      if (!payload.search_id || !payload.review_token) {
        reviewRequestStatus.textContent = "Run this inspiration search again before requesting a review.";
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        reviewRequestStatus.textContent = "Enter a valid email address.";
        reviewEmail.focus();
        return;
      }
      reviewRequestButton.disabled = true;
      reviewRequestStatus.textContent = "Sending your request...";
      try {
        var response = await fetch(endpoint + "/review-requests", {
          method: "POST",
          mode: "cors",
          credentials: "omit",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_id: payload.search_id, review_token: payload.review_token, email: email })
        });
        var result = await response.json().catch(function () { return {}; });
        if (!response.ok) throw new Error(result.error || "Your review request could not be sent.");
        payload.team_review = result.review || { requested: true, status: "requested", revision: 0 };
        state.currentPayload = payload;
        await persistActivePayload(payload);
        configureReviewRequest(payload);
        renderHistory();
      } catch (error) {
        reviewRequestButton.disabled = false;
        reviewRequestStatus.textContent = error.message || "Your review request could not be sent.";
      }
    }

    function configureReviewRequest(payload) {
      if (!reviewRequest || !reviewRequestForm) return;
      var enabled = Boolean(payload && payload.search_id && payload.review_token);
      var review = payload && payload.team_review || null;
      reviewRequest.hidden = !enabled || Boolean(review && review.status === "reviewed");
      if (!enabled) return;
      var requested = Boolean(review && review.requested);
      reviewRequestButton.disabled = requested;
      reviewEmail.disabled = requested;
      reviewRequestButton.textContent = requested ? "Review requested" : "Request team review";
      reviewRequestStatus.textContent = requested
        ? (review.status === "reviewed" ? "Team review completed. The refined matches are shown above." : "Request received. Refined matches will appear here after our team reviews them.")
        : "";
    }

    async function syncTeamReview(payload) {
      if (!payload || !payload.search_id || !payload.review_token) return;
      var response = await fetch(endpoint + "/review-status/" + encodeURIComponent(payload.search_id) + "?token=" + encodeURIComponent(payload.review_token), {
        method: "GET",
        mode: "cors",
        credentials: "omit"
      });
      if (!response.ok) return;
      var body = await response.json().catch(function () { return {}; });
      var review = body.review;
      if (!review) return;
      var currentRevision = Number(payload.team_review && payload.team_review.revision || 0);
      if (Number(review.revision || 0) <= currentRevision) {
        payload.team_review = Object.assign({}, payload.team_review || {}, {
          requested: Boolean(review.requested),
          status: review.status || "not_requested",
          requested_at: review.requested_at || null,
          reviewed_at: review.reviewed_at || null,
          shopper_note: review.shopper_note || ""
        });
        renderTeamReview(payload.team_review);
        configureReviewRequest(payload);
        return;
      }
      var updated = applyTeamReview(payload, review);
      state.currentPayload = updated;
      await persistActivePayload(updated);
      renderResults(updated, { scroll: false, skipReviewSync: true });
      renderHistory();
    }

    function applyTeamReview(payload, review) {
      var next = JSON.parse(JSON.stringify(payload || {}));
      next.groups = Array.isArray(next.groups) ? next.groups : [];
      (review.operations || []).forEach(function (operation) { applyTeamOperation(next.groups, operation); });
      next.groups.forEach(function (group) {
        var resultsList = group.results || [];
        group.direct_count = resultsList.filter(function (product) { return resultClassification(product) === "direct"; }).length;
        group.additional_count = Math.max(0, resultsList.length - group.direct_count);
      });
      next.team_review = {
        requested: Boolean(review.requested),
        status: review.status || "not_requested",
        requested_at: review.requested_at || null,
        reviewed_at: review.reviewed_at || null,
        revision: Number(review.revision || 0),
        shopper_note: review.shopper_note || ""
      };
      return next;
    }

    function applyTeamOperation(groups, operation) {
      if (operation.action === "add") {
        var targetGroup = findTeamReviewGroup(groups, operation) || groups[0];
        if (!targetGroup || !operation.product || !operation.product.handle) return;
        targetGroup.results = targetGroup.results || [];
        if (!targetGroup.results.some(function (product) { return sameProductHandle(product.handle, operation.product.handle); })) {
          targetGroup.results.push(operation.product);
        }
        return;
      }
      var located = findTeamReviewProduct(groups, operation.product_handle);
      if (!located) return;
      if (operation.action === "remove") located.group.results.splice(located.index, 1);
      if (operation.action === "classify") {
        located.product.classification = operation.classification;
        located.product.match = classificationLabel(operation.classification);
      }
      if (operation.action === "replace" && operation.product && operation.product.handle) {
        located.group.results.splice(located.index, 1, operation.product);
      }
    }

    function findTeamReviewGroup(groups, operation) {
      return groups.find(function (group) {
        var ingredient = group.ingredient || {};
        return String(ingredient.family || "").toLowerCase() === String(operation.group_family || "").toLowerCase()
          && String(ingredient.variety || "").toLowerCase() === String(operation.group_variety || "").toLowerCase();
      });
    }

    function findTeamReviewProduct(groups, handle) {
      for (var index = 0; index < groups.length; index += 1) {
        var resultsList = groups[index].results || [];
        var productIndex = resultsList.findIndex(function (product) { return sameProductHandle(product.handle, handle); });
        if (productIndex >= 0) return { group: groups[index], index: productIndex, product: resultsList[productIndex] };
      }
      return null;
    }

    function sameProductHandle(left, right) {
      return String(left || "").toLowerCase() === String(right || "").toLowerCase();
    }

    function renderTeamReview(review) {
      if (!teamReview) return;
      var reviewed = Boolean(review && review.status === "reviewed");
      teamReview.hidden = !reviewed;
      if (!reviewed) return;
      teamReviewMessage.textContent = review.shopper_note || "Our team has reviewed your image and updated the product suggestions below.";
      teamReviewDate.textContent = review.reviewed_at ? "Updated " + formatTeamReviewDate(review.reviewed_at) : "";
    }

    async function persistActivePayload(payload) {
      var active = historyEntry(state.entryId);
      if (!active) return;
      active.payload = payload;
      active.createdAt = Date.now();
      try {
        await saveHistoryEntry(active);
        await loadHistoryEntries();
      } catch (error) {
        renderHistory();
      }
    }

    function formatTeamReviewDate(value) {
      return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }).format(new Date(value));
    }
    function setBusy(busy, text) {
      submit.disabled = busy || !state.dataUrl;
      spinner.hidden = !busy;
      submitLabel.textContent = busy ? "Finding matches..." : "Find matching products";
      status.hidden = !busy;
      status.textContent = busy ? (text || "Working...") : "";
      form.setAttribute("aria-busy", busy ? "true" : "false");
    }

    function startProgress() {
      stopProgress();
      [
        [7000, "Looking for matching flowers and greenery..."],
        [17000, "Searching Bloomingful products..."],
        [30000, "Still finding matches for your image..."],
        [50000, "Your search is taking a little longer. Please keep this page open."]
      ].forEach(function (step) {
        state.progressTimers.push(window.setTimeout(function () {
          if (!spinner.hidden) status.textContent = step[1];
        }, step[0]));
      });
    }

    function stopProgress() {
      state.progressTimers.forEach(function (timer) { window.clearTimeout(timer); });
      state.progressTimers = [];
    }

    function showMessage(text) {
      message.textContent = text;
      message.hidden = false;
    }

    function clearMessage() {
      message.textContent = "";
      message.hidden = true;
    }

    function hideResults() {
      results.hidden = true;
      resultGroups.replaceChildren();
      state.searchId = "";
      state.projectProducts = {};
      if (projectSave) projectSave.hidden = true;
      if (reviewRequest) reviewRequest.hidden = true;
      if (teamReview) teamReview.hidden = true;
    }

    async function restoreHistory() {
      try {
        await loadHistoryEntries();
        var preferred = state.history.find(function (entry) { return entry.payload; }) || state.history[0];
        if (preferred) activateEntry(preferred, { scroll: false });
      } catch (error) {
        state.history = [];
        renderHistory();
      }
    }

    async function loadHistoryEntries() {
      state.history = await historyList();
      renderHistory();
    }

    function renderHistory() {
      if (!imageLibrary || !imageTabs) return;
      imageLibrary.hidden = !state.history.length;
      imageTabs.replaceChildren();
      state.history.forEach(function (entry) {
        var wrap = element("div", "bf-visual-finder__image-tab-wrap");
        wrap.setAttribute("role", "listitem");
        var button = element("button", "bf-visual-finder__image-tab");
        button.type = "button";
        button.dataset.historyId = entry.id;
        button.classList.toggle("is-active", entry.id === state.entryId);
        button.setAttribute("aria-pressed", entry.id === state.entryId ? "true" : "false");
        var image = document.createElement("img");
        image.src = entry.dataUrl;
        image.alt = entry.fileName || "Saved inspiration";
        var copy = document.createElement("span");
        var strong = document.createElement("strong");
        strong.textContent = entry.fileName || "Inspiration image";
        var statusText = document.createElement("small");
var teamStatus = entry.payload && entry.payload.team_review;
        statusText.textContent = teamStatus && teamStatus.status === "reviewed"
          ? "Team reviewed"
          : teamStatus && teamStatus.requested
            ? "Review requested"
            : entry.payload ? "Results ready" : "Ready to search";
        copy.append(strong, statusText);
        button.append(image, copy);
        var remove = element("button", "bf-visual-finder__image-remove");
        remove.type = "button";
        remove.dataset.historyRemove = entry.id;
        remove.setAttribute("aria-label", "Remove " + (entry.fileName || "inspiration image"));
        remove.textContent = "x";
        wrap.append(button, remove);
        imageTabs.append(wrap);
      });
    }

    async function handleImageTabAction(event) {
      var remove = event.target.closest("[data-history-remove]");
      if (remove) {
        await historyDelete(remove.dataset.historyRemove);
        await loadHistoryEntries();
        if (remove.dataset.historyRemove === state.entryId) {
          var next = state.history[0];
          if (next) activateEntry(next, { scroll: false });
          else resetWorkbench();
        }
        return;
      }
      var button = event.target.closest("[data-history-id]");
      if (!button) return;
      var entry = historyEntry(button.dataset.historyId);
      if (entry) activateEntry(entry, { scroll: false });
    }

    function activateEntry(entry, options) {
      state.entryId = entry.id;
      state.dataUrl = entry.dataUrl;
      state.currentPayload = entry.payload || null;
      previewImage.src = entry.dataUrl;
      fileName.textContent = entry.fileName || "Inspiration image";
      fileDetails.textContent = entry.width + " x " + entry.height + " px";
      previewPanel.hidden = false;
      replaceButton.hidden = false;
      uploadZone.classList.add("has-image");
      workbench.classList.add("has-image");
      setScopeValue(entry.scope || "all");
      submit.disabled = false;
      renderHistory();
      if (entry.payload) renderResults(entry.payload, { scroll: options && options.scroll });
      else hideResults();
    }

    function resetWorkbench() {
      state.dataUrl = "";
      state.entryId = "";
      state.currentPayload = null;
      previewImage.removeAttribute("src");
      previewPanel.hidden = true;
      replaceButton.hidden = true;
      uploadZone.classList.remove("has-image");
      workbench.classList.remove("has-image");
      submit.disabled = true;
      hideResults();
      renderHistory();
    }

    function historyEntry(id) {
      return state.history.find(function (entry) { return entry.id === id; }) || null;
    }

    function selectedScopeValue() {
      var selected = form.querySelector('input[name="scope"]:checked');
      return selected ? selected.value : "all";
    }

    function setScopeValue(value) {
      var choice = form.querySelector('input[name="scope"][value="' + String(value).replace(/"/g, "") + '"]');
      if (choice) choice.checked = true;
    }
  }

  async function prepareImage(file, options) {
    options = options || {};
    var source = await loadImage(file);
    if (!source.width || !source.height) throw new Error("This image has no readable dimensions.");
    var edge = Number(options.maxEdge || MAX_EDGE);
    var scale = Math.min(1, edge / Math.max(source.width, source.height));
    var width = Math.max(1, Math.round(source.width * scale));
    var height = Math.max(1, Math.round(source.height * scale));
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d", { alpha: false });
    if (!context) throw new Error("This browser cannot prepare the image.");
    canvas.width = width;
    canvas.height = height;
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, width, height);
    context.drawImage(source.image, 0, 0, width, height);
    if (source.close) source.close();
    var quality = Number(options.quality || JPEG_QUALITY);
    var blob = await canvasToBlob(canvas, quality);
    while (blob.size > MAX_PREPARED_BYTES && quality > 0.56) {
      quality -= 0.1;
      blob = await canvasToBlob(canvas, quality);
    }
    await verifyPreparedBlob(blob);
    return { dataUrl: await blobToDataUrl(blob), width: width, height: height };
  }

  async function loadImage(file) {
    if (typeof createImageBitmap === "function") {
      try {
        var bitmap;
        try { bitmap = await createImageBitmap(file, { imageOrientation: "from-image" }); }
        catch (optionError) { bitmap = await createImageBitmap(file); }
        return { image: bitmap, width: bitmap.width, height: bitmap.height, close: function () { bitmap.close(); } };
      } catch (bitmapError) {
        // Fall through to the browser image decoder for formats handled differently by Safari and Chromium.
      }
    }
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var image = new Image();
      image.onload = function () {
        URL.revokeObjectURL(url);
        resolve({ image: image, width: image.naturalWidth, height: image.naturalHeight });
      };
      image.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error("We couldn't open this image. Try saving it as a JPG or PNG."));
      };
      image.src = url;
    });
  }

  function canvasToBlob(canvas, quality) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob || blob.size < 256) reject(new Error("The prepared image was empty."));
        else resolve(blob);
      }, "image/jpeg", quality);
    });
  }

  async function verifyPreparedBlob(blob) {
    var decoded = await loadImage(blob);
    if (!decoded.width || !decoded.height) throw new Error("The prepared image could not be decoded.");
    if (decoded.close) decoded.close();
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(String(reader.result || "")); };
      reader.onerror = function () { reject(new Error("The prepared image could not be read.")); };
      reader.readAsDataURL(blob);
    });
  }

  function dataUrlToBlob(dataUrl) {
    return fetch(dataUrl).then(function (response) { return response.blob(); });
  }

  function isAllowedFile(file) {
    if (ALLOWED_TYPES.indexOf(String(file.type || "").toLowerCase()) !== -1) return true;
    return /\.(?:jpe?g|png|webp)$/i.test(String(file.name || ""));
  }

  function resultClassification(product) {
    var value = String(product && product.classification || "").toLowerCase();
    if (["direct", "close", "palette"].indexOf(value) !== -1) return value;
    var match = String(product && product.match || "").toLowerCase();
    if (match.indexOf("palette") !== -1) return "palette";
    if (match.indexOf("substitute") !== -1) return "close";
    return "direct";
  }

  function classificationLabel(value) {
    return value === "direct" ? "Pictured in inspiration" : value === "close" ? "Close alternative" : "Palette suggestion";
  }

  function localId() {
    return "local-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 9);
  }

  async function saveHistoryEntry(entry) {
    var db = await openHistoryDb();
    await idbRequest(db.transaction(HISTORY_STORE, "readwrite").objectStore(HISTORY_STORE).put(entry));
    await trimHistory(db);
  }

  async function historyList() {
    var db = await openHistoryDb();
    var rows = await idbRequest(db.transaction(HISTORY_STORE, "readonly").objectStore(HISTORY_STORE).getAll());
    var cutoff = Date.now() - HISTORY_TTL_MS;
    var valid = rows.filter(function (entry) { return Number(entry.createdAt || 0) >= cutoff; })
      .sort(function (a, b) { return Number(b.createdAt || 0) - Number(a.createdAt || 0); });
    if (valid.length !== rows.length) await trimHistory(db);
    return valid.slice(0, HISTORY_MAX_ENTRIES);
  }

  async function historyDelete(id) {
    var db = await openHistoryDb();
    await idbRequest(db.transaction(HISTORY_STORE, "readwrite").objectStore(HISTORY_STORE).delete(id));
  }

  function openHistoryDb() {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB) return reject(new Error("Local inspiration history is unavailable."));
      var request = window.indexedDB.open(HISTORY_DB_NAME, 1);
      request.onupgradeneeded = function () {
        if (!request.result.objectStoreNames.contains(HISTORY_STORE)) request.result.createObjectStore(HISTORY_STORE, { keyPath: "id" });
      };
      request.onsuccess = function () { resolve(request.result); };
      request.onerror = function () { reject(request.error || new Error("Local inspiration history could not open.")); };
    });
  }

  async function trimHistory(db) {
    var rows = await idbRequest(db.transaction(HISTORY_STORE, "readonly").objectStore(HISTORY_STORE).getAll());
    var cutoff = Date.now() - HISTORY_TTL_MS;
    var ordered = rows.sort(function (a, b) { return Number(b.createdAt || 0) - Number(a.createdAt || 0); });
    var bytes = 0;
    var removeIds = [];
    ordered.forEach(function (entry, index) {
      bytes += String(entry.dataUrl || "").length;
      if (Number(entry.createdAt || 0) < cutoff || index >= HISTORY_MAX_ENTRIES || bytes > HISTORY_MAX_BYTES) removeIds.push(entry.id);
    });
    for (var index = 0; index < removeIds.length; index += 1) {
      await idbRequest(db.transaction(HISTORY_STORE, "readwrite").objectStore(HISTORY_STORE).delete(removeIds[index]));
    }
  }

  function idbRequest(request) {
    return new Promise(function (resolve, reject) {
      request.onsuccess = function () { resolve(request.result); };
      request.onerror = function () { reject(request.error || new Error("Local inspiration history request failed.")); };
    });
  }

  function safeStoreUrl(value) {
    try {
      var url = new URL(value, "https://bloomingful.com");
      if (["bloomingful.com", "www.bloomingful.com"].indexOf(url.hostname) === -1) return "/pages/dried-preserved-florals";
      return url.href;
    } catch (error) {
      return "/pages/dried-preserved-florals";
    }
  }

  function safeImageUrl(value) {
    try {
      var url = new URL(value);
      return url.protocol === "https:" && (url.hostname.endsWith("shopify.com") || url.hostname.endsWith("shopifycdn.com"));
    } catch (error) {
      return false;
    }
  }

  function money(value) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(value));
  }

  function labelize(value) {
    return String(value || "").replace(/[-_]+/g, " ").replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function element(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function start() {
    document.querySelectorAll("[data-bf-visual-finder]").forEach(initialize);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  document.addEventListener("shopify:section:load", start);
})();
